@if (hasMembersAssigned()) {
  <div class="employees-container">
    <div class="header-container">
      <div class="title-container">
        <span class="title">{{
          'tlc.positions.position_details_dialog.tabs.employees.employee_list.heading' | translate
        }}</span>
        <rt-button variant="primary" (click)="assignMembers()">
          <rt-icon name="add" />
          <span>{{
            'tlc.positions.position_details_dialog.tabs.employees.employee_list.add_button'
              | translate
          }}</span>
        </rt-button>
      </div>
      <rt-input
        [placeholder]="'tlc.common.search' | translate"
        (valueChange)="onSearchChange($event)"
        [value]="searchQuery()"
        [hasClearButton]="true"
      >
        <rt-icon name="search" prefix />
      </rt-input>
    </div>
    @if (filteredMembers().length === 0) {
      <rt-empty-state
        icon="search"
        [title]="
          'tlc.positions.position_details_dialog.tabs.employees.empty_state.no_results.title'
            | translate
        "
        [desc]="
          'tlc.positions.position_details_dialog.tabs.employees.empty_state.no_results.desc'
            | translate
        "
      />
    } @else {
      <div class="employee-list">
        @for (member of filteredMembers(); track member.guid) {
          <tlc-position-details-member-item
            [member]="member"
            (unassignMember)="unassignMember(member)"
            (viewMember)="viewMemberProfile(member.guid)"
          />
        }
      </div>
    }
  </div>
} @else {
  <div class="empty-state-container">
    <rt-empty-state
      icon="positions"
      [title]="'tlc.positions.position_details_dialog.tabs.employees.empty_state.title' | translate"
      [desc]="'tlc.positions.position_details_dialog.tabs.employees.empty_state.desc' | translate"
    >
      <rt-button variant="primary" (click)="assignMembers()">
        <rt-icon name="add" />
        <span>{{
          'tlc.positions.position_details_dialog.tabs.employees.empty_state.cta_button' | translate
        }}</span>
      </rt-button>
    </rt-empty-state>
  </div>
}
